module.exports = __webpack_public_path__ + "static/media/Hundered_b_DNA_Ladder_Marker_M.55fbc84e.svg";